import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/organizations/$organizationId/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/organizations/$organizationId/overview",
      params: { organizationId: params.organizationId },
    });
  },
});
